import React from "react";
import _ from "lodash";
// reactstrap misc
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button,
    DropdownItem,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle, PaginationItem, PaginationLink, Pagination
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine"
import {connect} from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import SelectRow from "../../components/Select/SelectRow";
import FormRow from "../../components/Row/FormRow";
import {AvForm} from "availity-reactstrap-validation";
import {Utilites} from "../../core/Utilites";

class DailyOrder extends CoreEngine {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            dataSource: [],
            deliverydate:"",
            deliverydatelist:[],
            page:0,
            type:"admin",
            pageSize:10,
            count:0,
            innerloading:true,
        };
        this.pathname = "dailyorder";
        this.engine = new RequestEngine();
    }

    componentDidMount() {
        this.callPage(0)
    }



    async handleDelete(valueid) {

        if(window.confirm("are you sure ?")){
            this.props.loadingAction(true)
            const result = await this.engine.deleteItem(this.pathname,valueid)
            if(result){
                this.handlePage();
            }
            this.props.loadingAction(false)
        }


    }

    handleView(index,dataid) {
        const data = this.state.dataSource[index].data
        window.open('http://apix.freshvery.com/upload/'+data.filename);
    }

    async handleSendEmail(valueid) {
        console.log(valueid);
        this.props.loadingAction(true)
        const result = await this.engine.sendItem(this.pathname,valueid)
        if(result){
            this.handlePage();
        }
        this.props.loadingAction(false)

    }

    handleActions(index,item) {

        const {type} = this.state
        return (<UncontrolledDropdown>
            <DropdownToggle
                aria-expanded={false}
                aria-haspopup={true}
                caret
                className="btn-round btn-block"
                color="primary"
                data-toggle="dropdown"
                id="dropdownMenuButton"
                type="button"
            >
                Actions
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem  eventKey="1" onClick={()=>this.handleView(index,item.id)} >Download</DropdownItem>
                <DropdownItem  eventKey="1" onClick={()=>this.handleSendEmail(item.id)} >Send Email</DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>)
    }



    async handleViewBenExport() {
        if(this.state.deliverydate.length<2){
            Utilites.showErrorMessage("Please select delivery date");
            return;
        }

        let deliverydate = this.state.deliverydate.replace('/', '-')
        deliverydate = deliverydate.replace('/', '-')
        await  this.engine.exportCSV("order","/export/"+deliverydate);
    }


    async handleViewBenExportAll() {

        await  this.engine.exportCSV("order","/export/all")
    }
    putrowstatus(item){

        if(item.status === 0){

            return "Pending"

        }else if(item.status === 1){

            return "Processing"
        }else if(item.status === 2){

            return "Completed"
        }

    }


    renderstatusinfo(item){

        return item.status+" "+(item.canedit?" (can edit) ":"")

    }



    async callPage(page,pageSize=10,filtered = []) {


        this.setState({
            innerloading : true,
        })
        const response = await  this.engine.postItem(this.pathname,"/list/"+page+"/"+pageSize,filtered);


        if(response && response.status === 200){



            this.setState({
                    isLoading: false,
                    innerloading:false,
                    count:response.data.data.count,
                    page:page,
                    pageSize:pageSize,
                    dataSource: response.data.data.data.map((item, key) => {
                        return {
                            id: key,
                            data:item,
                            name: <a href={"http://apix.freshvery.com/upload/"+item.filename} target={"_blank"}>{item.name}</a>,
                            date: item.datex,
                            sent:item.sent?"YES":"NO",
                            created:this.renderDate(item.createdAt),
                            actions: (
                                this.handleActions(key,item)
                            )
                        };
                    })
                }
            );
        }
        this.props.loadingAction(false);
    }

    handlePage(page) {
        this.props.loadingAction(true);
        this.callPage(page,this.state.pageSize)
    }





    render() {
        let {dataSource,innerloading,deliverydate,deliverydatelist,count,pageSize} = this.state;


        const pageNumbers = [];
        for (let i = 1; i <= count; i++) {
            pageNumbers.push(i);
        }
        const renderPageNumbers = pageNumbers.map((number, index) => {
            return (
                <PaginationItem   key={index}>
                    <PaginationLink
                        onClick={()=>this.callPage(number,pageSize)}
                    >
                        {number}
                    </PaginationLink>
                </PaginationItem>
            );
        })

        /*
           name: item.name,
                            date: item.date,
                            filename:item.filename,
         */
        let columns = [
            {
                Header: "Name",
                accessor: "name"
            },
            {
                Header: "Sent",
                accessor: "sent",
            },
            {
                Header: "Created",
                accessor: "created"
            },

            {
                Header: "Actions",
                accessor: "actions",
                sortable: false,
                filterable: false
            }

        ]




        return (
            <>

                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4" className="pull-left">List</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Pagination
                                        className="pagination pagination-primary"
                                        listClassName="pagination-primary"
                                        style={{    overflow: "scroll"}}
                                    >
                                        {renderPageNumbers}
                                    </Pagination>
                                    <ReactTable
                                        data={dataSource}
                                        defaultFilterMethod={this.filterCaseInsensitive}
                                        filterable
                                        manual
                                        loading={innerloading}
                                        columns={columns}
                                        defaultPageSize={10}
                                        showPaginationTop
                                        onFetchData={(state, instance) => {
                                            this.setState({
                                                innerloading:true
                                            })
                                            const filtered = state.filtered
                                            this.callPage(state.page, state.pageSize,filtered)
                                        }}
                                        showPaginationBottom={false}
                                        /*
                                          You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                                        */
                                        className="-striped -highlight primary-pagination"
                                    />

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </>
        );
    }
}



const mapDispatchToProps = dispatch => ({
    loadingAction: (payload) => dispatch(loadingAction(payload))
});
export default connect(null, mapDispatchToProps)(DailyOrder);
